<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { fade } from 'svelte/transition';
  import { AppState, SetNotification } from '../../../etc/stores';
  import { pluralizeI18n } from '../../../etc/utils';
  import { replaceVariables } from '../../../i18n';
  import Close from '../../icons/Close.svelte';
  import AnimatedCoin from '../../misc/AnimatedCoin.svelte';

  const positionSettings = $AppState.settings || {};

  const t = (text: string, values: any) => {
    return replaceVariables($_(`messages.${text}`), values);
  };

  const close = () => {
    SetNotification('', true);
  };
</script>

<div
  class="remind-wix-postcheckout {`twism-${positionSettings.position}`}"
  in:fade
>
  <div class="remind-wix-postcheckout--close" on:click={close}>
    <Close fill={$AppState.theme.colors.typography} />
  </div>
  <div class="remind-wix-postcheckout--brand">
    <AnimatedCoin
      image={$AppState.business.logo.publicPath.large}
      scale="0.75"
    />
  </div>
  <div class="remind-wix-postcheckout--text">
    <p>
      {@html t(
        pluralizeI18n('credit_card_coins_mobile', $AppState.website.coins),
        { COIN: $AppState.website.coins }
      )}
    </p>
  </div>
</div>

<style lang="scss">
  @use './styles.scss' as *;
  .remind-wix-postcheckout {
    width: 405px;
    height: 123px;
    border-radius: 16px;
    background: #ffffff;
    box-shadow: 0px 14px 48px -13px rgba(4, 33, 67, 0.26);
    display: flex;
    align-items: center;
    position: absolute;
    top: -215%;
    overflow: hidden;

    @media screen and (max-width: 468px) {
      width: 327px;
      max-width: 85vw;
    }

    &.twism-bottomRight {
      right: 0;
    }

    &--brand {
      height: 100%;
      min-width: 112px;
      background: var(--twism-theme-primary600);
      display: flex;
      align-items: center;
      justify-content: center;

      @media screen and (max-width: 468px) {
        min-width: 90px;
      }
    }

    &--text {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 42px 0 20px;

      @media screen and (max-width: 468px) {
        padding: 0 24px 0 16px;
      }

      p {
        font-weight: 400;
        font-size: 14px;
        line-height: 154%;
      }
    }

    &--close {
      position: absolute;
      right: 0;
      top: 0;
      opacity: 0.3;
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  :global(.remind-wix-postcheckout--text strong) {
    color: var(--twism-theme-primary200);
  }
</style>
